// src/pages/T321ConfigPage.jsx
// Admin Config — Manage T321 team permission configurations (3 paths: Base, Regulated, NOIR)

import React, { useState, useEffect } from 'react';
import { listT321TeamConfigs, saveT321TeamConfig, deleteT321TeamConfig } from '../services/api';

// ════════════════════════════════════════════════════════════════
// T321 PERMISSION DATA — Mirrors T321Request.jsx paths
// ════════════════════════════════════════════════════════════════

const BASE_PERMISSIONS = [
    { id: 't321_os_base_access_br', name: "Tenant 321 - OS Base Access BR", path: 'A' },
    { id: 't321_os_base_access_ca', name: "Tenant 321 - OS Base Access CA", path: 'A' },
    { id: 't321_routing_and_rcc_permissions', name: "Tenant 321 - Routing and RCC Permissions", path: 'A' },
    { id: 't321_secure_link_access', name: "Tenant 321 - Secure Link Access", path: 'A' },
    { id: 't321_secure_link_creation_search_scopes', name: "Tenant 321 - Secure Link Creation - Search scopes", path: 'A' },
    { id: 't321_siv_signed_access', name: "Tenant 321 - SIV Signed access", path: 'A' },
    { id: 't321_sps_kyc_access', name: "Tenant 321 - SPS KYC Access", path: 'A' },
    { id: 't321_workplan_designer', name: "Tenant 321 - Workplan Designer", path: 'A' },
    { id: 't321_base_access_bindle', name: "Tenant 321 Base Access - Bindle", path: 'A' },
    { id: 't321_beta_base_and_ufs', name: "Tenant 321 Beta - Base and UFS", path: 'A' },
    { id: 't321_bulk_actions_br', name: "Tenant 321 Bulk Actions - BR", path: 'A' },
    { id: 't321_bulk_actions_ca', name: "Tenant 321 Bulk Actions - CA", path: 'A' },
    { id: 't321_case_bypass', name: "Tenant 321 Case Bypass", path: 'A' },
    { id: 't321_peeknow_bindle', name: "Tenant 321 PeekNow - Bindle", path: 'A' },
    { id: 't321_search_bar_bindle', name: "Tenant 321 Search Bar - Bindle", path: 'A' },
    { id: 'calypsoinvestigators_soa_siv_na_team', name: "CalypsoInvestigators-SOA-SIV-NA-Team", path: 'A' },
    { id: 'calypsoinvestigators_verifiedid_approval_na', name: "CalypsoInvestigators-VerifiedId-Approval-NA", path: 'A' },
    { id: 'calypsoinvestigators_verifiedid_approval_na_cn', name: "CalypsoInvestigators-VerifiedId-Approval-NA-CN", path: 'A' },
    { id: 'arvt_allow_ipv_page', name: "ARVT - Allow IPV page", path: 'A' },
    { id: 'arvt_audit_access', name: "ARVT - Audit access", path: 'A' },
];

const REGULATED_PERMISSIONS = [
    { id: 'calypso_soa_siv_na_readonlytask', name: "Calypso-SOA-SIV-NA-ReadOnlyTask", path: 'B' },
    { id: 'calypsocustomeridgc_signedinlink', name: "CalypsoCustomerIdGC-Signedinlink", path: 'B' },
    { id: 'calypsocustomeridna_signedinlink', name: "CalypsoCustomerIdNA-Signedinlink", path: 'B' },
    { id: 'calypsonacustomeridsearchsignonly', name: "CalypsoNACustomerIdSearchSignOnly", path: 'B' },
    { id: 'calypsotaskidkyc_eu_fe_remus_eu_signedinlink', name: "CalypsoTaskIdKYC-EU-FE-Remus-EU-Signedinlink", path: 'B' },
    { id: 'calypso_ape_user', name: "calypso-ape-user", path: 'B' },
    { id: 'calypso_ape_users_team', name: "calypso-ape-users team", path: 'B' },
    { id: 'calypso_apuk_user', name: "calypso-apuk-user", path: 'B' },
    { id: 'calypso_risk_level_override', name: "calypso-risk-level-override", path: 'B' },
    { id: 'calypso_risk_level_override_aws_mp', name: "calypso-risk-level-override-aws-mp", path: 'B' },
    { id: 'calypso_sw_kyc_na_viewaccess_full', name: "Calypso-SW-KYC-NA-ViewAccess-Full", path: 'B' },
    { id: 'calypso_sw_kyc_na_viewaccess_task', name: "Calypso-SW-KYC-NA-ViewAccess-Task", path: 'B' },
    { id: 'calypso_sw_kyc_na_workaccess_tier1', name: "Calypso-SW-KYC-NA-WorkAccess-Tier1", path: 'B' },
    { id: 'calypso_sw_kyc_na_workaccess_tier2', name: "Calypso-SW-KYC-NA-WorkAccess-Tier2", path: 'B' },
    { id: 'calypso_sw_kyc_na_workaccess_tier3', name: "Calypso-SW-KYC-NA-WorkAccess-Tier3", path: 'B' },
    { id: 'calypsoapetier1accesseu', name: "CalypsoAPETier1AccessEU", path: 'B' },
    { id: 'calypsoapetier2accesseu', name: "CalypsoAPETier2AccessEU", path: 'B' },
    { id: 'calypsoapetier3accesseu', name: "CalypsoAPETier3AccessEU", path: 'B' },
    { id: 'calypsobrtier1access', name: "CalypsoBRTier1Access", path: 'B' },
    { id: 'calypsobrtier2access', name: "CalypsoBRTier2Access", path: 'B' },
    { id: 'calypsobrtier3access', name: "CalypsoBRTier3Access", path: 'B' },
    { id: 'calypsobrviewaccesstask', name: "CalypsoBRViewAccessTask", path: 'B' },
    { id: 'calypsobulkactionsprod', name: "CalypsoBulkActionsProd", path: 'B' },
    { id: 'calypsocakycsignedlinkaccess', name: "CalypsoCAKYCSignedlinkaccess", path: 'B' },
    { id: 'calypsocatier1access', name: "CalypsoCATier1Access", path: 'B' },
    { id: 'calypsocatier2access', name: "CalypsoCATier2Access", path: 'B' },
    { id: 'calypsocatier3access', name: "CalypsoCATier3Access", path: 'B' },
    { id: 'calypsocaviewaccesstask', name: "CalypsoCAViewAccessTask", path: 'B' },
    { id: 'calypsocustomeridbr_signedinlink', name: "CalypsoCustomerIdBR-Signedinlink", path: 'B' },
    { id: 'calypsocustomeridkyc_eu_signedinlink', name: "CalypsoCustomerIdKYC-EU-Signedinlink", path: 'B' },
    { id: 'calypsoemailutilityeuprodsearchsignonly', name: "CalypsoEmailUtilityEUProdSearchSignOnly", path: 'B' },
    { id: 'calypsoeucustomeridsearchsignonly', name: "CalypsoEUCustomerIdSearchSignOnly", path: 'B' },
    { id: 'calypsogctier1access', name: "CalypsoGCTier1Access", path: 'B' },
    { id: 'calypsogctier3access', name: "CalypsoGCTier3Access", path: 'B' },
    { id: 'calypsoinvestigators_aws_mp_eu_tier1', name: "CalypsoInvestigators-AWS-MP-EU-Tier1", path: 'B' },
    { id: 'calypsoinvestigators_aws_mp_eu_tier2', name: "CalypsoInvestigators-AWS-MP-EU-Tier2", path: 'B' },
    { id: 'calypsoinvestigators_aws_mp_eu_tier3', name: "CalypsoInvestigators-AWS-MP-EU-Tier3", path: 'B' },
    { id: 'calypsomanagers_aws_mp_eu', name: "CalypsoManagers-AWS-MP-EU", path: 'B' },
    { id: 'calypsounfetteredsearchca', name: "CalypsoUnfetteredSearchCA", path: 'B' },
    { id: 'eu_cams_kyc_documents', name: "eu-cams-kyc-documents", path: 'B' },
    { id: 'rampconsole_eu_compliance', name: "RampConsole-EU-Compliance", path: 'B' },
    { id: 'rampconsole_eu_dloa', name: "rampconsole-eu-dloa", path: 'B' },
    { id: 'rampconsole_eu_doc_dpl', name: "rampconsole-eu-doc-dpl", path: 'B' },
    { id: 'rampconsole_eu_doc_sanctions', name: "rampconsole-eu-doc-sanctions", path: 'B' },
    { id: 'rampconsole_eu_full_access', name: "rampconsole-eu-full-access", path: 'B' },
    { id: 'rampconsole_eu_sanctionsinvestigators', name: "rampconsole-eu-sanctionsinvestigators", path: 'B' },
    { id: 'rca_sop_users', name: "rca-sop-users", path: 'B' },
    { id: 'rcs_pml_reviewers', name: "RCS PML Reviewers", path: 'B' },
    { id: 'rcs_apuk_sam_inv', name: "RCS-APUK-SAM-INV", path: 'B' },
    { id: 'trms_kyc_users_ldap_access_to_kyc_community_help_page_country_guides_and_others', name: "TRMS-KYC-USERS - LDAP - Access to KYC Community Help Page - Country Guides and others", path: 'B' },
    { id: 'trms_kyc_users_ant_to_be_deprecated', name: "TRMS-KYC-USERS_ANT to be Deprecated", path: 'B' },
    { id: 'trms_rca_users', name: "trms-rca-users", path: 'B' },
    { id: 'acsuk_compliance_reporting_uk_sharedmb', name: "acsuk-compliance-reporting-uk-SharedMB", path: 'B' },
    { id: 'ape_compliance_policy_ldap', name: "ape-compliance-policy_ldap", path: 'B' },
    { id: 'ape_sam_test', name: "ape-sam-test", path: 'B' },
    { id: 'ape_screening_tier3_queues', name: "ape-screening-tier3-queues", path: 'B' },
    { id: 'ape_screening_tier4_queues', name: "ape-screening-tier4-queues", path: 'B' },
    { id: 'apuk_investigator_dashboard_access', name: "APUK Investigator Dashboard Access", path: 'B' },
    { id: 'apuk_compliance_restricted_policy', name: "APUK-Compliance-Restricted-Policy", path: 'B' },
    { id: 'apuk_sam_queries_wiki', name: "APUK-SAM-Queries-Wiki", path: 'B' },
    { id: 'apuk_screening_tier3_queues', name: "apuk-screening-tier3-queues", path: 'B' },
    { id: 'apuk_screening_tier4_queues', name: "apuk-screening-tier4-queues", path: 'B' },
    { id: 'compliance_attributes_prod', name: "compliance-attributes-prod", path: 'B' },
];

const NOIR_PERMISSIONS = [
    { id: 'noir_apuk_attachment_prod', name: "Noir-APUK-Attachment-Prod", path: 'C' },
    { id: 'noir_apuk_reports_prod', name: "Noir-APUK-Reports-Prod", path: 'C' },
    { id: 'noir_case_management_attachments_eu', name: "Noir-Case-Management-Attachments-EU", path: 'C' },
    { id: 'noir_acsuk_wfm', name: "NOIR_ACSUK_WFM", path: 'C' },
    { id: 'noir_aml_compliance_ape_eu_tier4', name: "Noir_AML_Compliance_APE_EU_Tier4", path: 'C' },
    { id: 'noir_aml_exam_acsza', name: "Noir_AML_EXAM_ACSZA", path: 'C' },
    { id: 'noir_aml_ext_request_acsza', name: "Noir_AML_EXT_REQUEST_ACSZA", path: 'C' },
    { id: 'noir_aml_ext_request_ape', name: "Noir_AML_EXT_REQUEST_APE", path: 'C' },
    { id: 'noir_aml_gc_buyer_ape_eu_mgr', name: "Noir_AML_GC_Buyer_APE_EU_Mgr", path: 'C' },
    { id: 'noir_aml_gc_buyer_ape_eu_t1', name: "Noir_AML_GC_Buyer_APE_EU_T1", path: 'C' },
    { id: 'noir_aml_gc_buyer_ape_eu_t2', name: "Noir_AML_GC_Buyer_APE_EU_T2", path: 'C' },
    { id: 'noir_aml_gc_buyer_ape_eu_t2qa', name: "Noir_AML_GC_Buyer_APE_EU_T2QA", path: 'C' },
    { id: 'noir_aml_gc_buyer_ape_eu_t3', name: "Noir_AML_GC_Buyer_APE_EU_T3", path: 'C' },
    { id: 'noir_aml_gc_buyer_ape_eu_t4', name: "Noir_AML_GC_Buyer_APE_EU_T4", path: 'C' },
    { id: 'noir_aml_gc_buyer_apuk_uk_mgr', name: "Noir_AML_GC_Buyer_APUK_UK_Mgr", path: 'C' },
    { id: 'noir_aml_gc_buyer_apuk_uk_t1', name: "Noir_AML_GC_Buyer_APUK_UK_T1", path: 'C' },
    { id: 'noir_aml_gc_buyer_apuk_uk_t2', name: "Noir_AML_GC_Buyer_APUK_UK_T2", path: 'C' },
    { id: 'noir_aml_gc_buyer_apuk_uk_t2qa', name: "Noir_AML_GC_Buyer_APUK_UK_T2QA", path: 'C' },
    { id: 'noir_aml_gc_buyer_apuk_uk_t3', name: "Noir_AML_GC_Buyer_APUK_UK_T3", path: 'C' },
    { id: 'noir_aml_gc_buyer_apuk_uk_t4', name: "Noir_AML_GC_Buyer_APUK_UK_T4", path: 'C' },
    { id: 'noir_aml_mar_ape_eu_manager', name: "Noir_AML_MAR_APE_EU_Manager", path: 'C' },
    { id: 'noir_aml_mar_ape_eu_tier2', name: "Noir_AML_MAR_APE_EU_Tier2", path: 'C' },
    { id: 'noir_aml_mar_ape_eu_tier2_qa', name: "Noir_AML_MAR_APE_EU_Tier2_QA", path: 'C' },
    { id: 'noir_aml_mar_ape_eu_tier3', name: "Noir_AML_MAR_APE_EU_Tier3", path: 'C' },
    { id: 'noir_aml_mar_ape_eu_tier4', name: "Noir_AML_MAR_APE_EU_Tier4", path: 'C' },
    { id: 'noir_aml_mar_ape_standard_clustered', name: "Noir_AML_MAR_APE_Standard_Clustered", path: 'C' },
    { id: 'noir_aml_sam_ape_eu_manager', name: "Noir_AML_SAM_APE_EU_Manager", path: 'C' },
    { id: 'noir_aml_sam_ape_eu_tier1', name: "Noir_AML_SAM_APE_EU_Tier1", path: 'C' },
    { id: 'noir_aml_sam_ape_eu_tier2', name: "Noir_AML_SAM_APE_EU_Tier2", path: 'C' },
    { id: 'noir_aml_sam_ape_eu_tier2_qa', name: "Noir_AML_SAM_APE_EU_Tier2_QA", path: 'C' },
    { id: 'noir_aml_sam_ape_eu_tier3', name: "Noir_AML_SAM_APE_EU_Tier3", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_manager', name: "Noir_AML_SAM_SELLER_ACSZA_Manager", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_qa', name: "Noir_AML_SAM_SELLER_ACSZA_QA", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_tier1', name: "Noir_AML_SAM_SELLER_ACSZA_Tier1", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_tier1_test', name: "Noir_AML_SAM_SELLER_ACSZA_Tier1_Test", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_tier2', name: "Noir_AML_SAM_SELLER_ACSZA_Tier2", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_tier2_test', name: "Noir_AML_SAM_SELLER_ACSZA_Tier2_Test", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_tier3', name: "Noir_AML_SAM_SELLER_ACSZA_Tier3", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_tier4', name: "Noir_AML_SAM_SELLER_ACSZA_Tier4", path: 'C' },
    { id: 'noir_aml_sam_seller_acsza_wfm', name: "Noir_AML_SAM_SELLER_ACSZA_WFM", path: 'C' },
    { id: 'noir_aml_sam_sellerlending_acs_uk_manager', name: "Noir_AML_SAM_SELLERLENDING_ACS_UK_Manager", path: 'C' },
    { id: 'noir_aml_sam_sellerlending_acs_uk_tier1', name: "Noir_AML_SAM_SELLERLENDING_ACS_UK_Tier1", path: 'C' },
    { id: 'noir_aml_sam_sellerlending_acs_uk_tier2', name: "Noir_AML_SAM_SELLERLENDING_ACS_UK_Tier2", path: 'C' },
    { id: 'noir_aml_sam_sellerlending_acs_uk_tier2_qa', name: "Noir_AML_SAM_SELLERLENDING_ACS_UK_Tier2_QA", path: 'C' },
    { id: 'noir_aml_sam_sellerlending_acs_uk_tier3', name: "Noir_AML_SAM_SELLERLENDING_ACS_UK_Tier3", path: 'C' },
    { id: 'noir_aml_sam_sellerlending_acs_uk_tier4', name: "Noir_AML_SAM_SELLERLENDING_ACS_UK_Tier4", path: 'C' },
    { id: 'noir_aml_trms_mar_eu_manager', name: "Noir_AML_TRMS_MAR_EU_Manager", path: 'C' },
    { id: 'noir_aml_trms_sam_eu_manager', name: "Noir_AML_TRMS_SAM_EU_Manager", path: 'C' },
    { id: 'noir_ape_automated_filing', name: "Noir_APE_Automated_Filing", path: 'C' },
    { id: 'noir_ape_eu_qa', name: "NOIR_APE_EU_QA", path: 'C' },
    { id: 'noir_ape_eu_wfm', name: "NOIR_APE_EU_WFM", path: 'C' },
    { id: 'noir_apuk_wfm', name: "NOIR_APUK_WFM", path: 'C' },
    { id: 'noir_awsmp_sam_ape_eu_manager', name: "Noir_AWSMP_SAM_APE_EU_Manager", path: 'C' },
    { id: 'noir_awsmp_sam_ape_eu_tier1', name: "Noir_AWSMP_SAM_APE_EU_Tier1", path: 'C' },
    { id: 'noir_awsmp_sam_ape_eu_tier2', name: "Noir_AWSMP_SAM_APE_EU_Tier2", path: 'C' },
    { id: 'noir_awsmp_sam_ape_eu_tier3', name: "Noir_AWSMP_SAM_APE_EU_Tier3", path: 'C' },
    { id: 'noir_awsmp_sam_ape_eu_tier4', name: "Noir_AWSMP_SAM_APE_EU_Tier4", path: 'C' },
    { id: 'noir_context_acs_uk', name: "Noir_CONTEXT_ACS_UK", path: 'C' },
    { id: 'noir_context_acsza', name: "Noir_CONTEXT_ACSZA", path: 'C' },
    { id: 'noir_context_ape_gc_sam', name: "Noir_CONTEXT_APE_GC_SAM", path: 'C' },
    { id: 'noir_context_ape_sam', name: "Noir_Context_APE_SAM", path: 'C' },
    { id: 'noir_context_apuk_gc_sam', name: "Noir_CONTEXT_APUK_GC_SAM", path: 'C' },
    { id: 'noir_idv_context_acs_uk', name: "Noir_IDV_CONTEXT_ACS_UK", path: 'C' },
    { id: 'noir_sar_context_sam_apuk_uk', name: "Noir_SAR_CONTEXT_SAM_APUK_UK", path: 'C' },
    { id: 'noir_sar_ext_request_apuk_uk', name: "Noir_SAR_EXT_REQUEST_APUK_UK", path: 'C' },
    { id: 'noir_sar_mar_apuk_uk_tier2', name: "Noir_SAR_MAR_APUK_UK_Tier2", path: 'C' },
    { id: 'noir_sar_mar_apuk_uk_tier2_manager', name: "Noir_SAR_MAR_APUK_UK_Tier2_Manager", path: 'C' },
    { id: 'noir_sar_mar_apuk_uk_tier2_qa', name: "Noir_SAR_MAR_APUK_UK_Tier2_QA", path: 'C' },
    { id: 'noir_sar_mar_apuk_uk_tier2_qa_manager', name: "Noir_SAR_MAR_APUK_UK_Tier2_QA_Manager", path: 'C' },
    { id: 'noir_sar_mar_apuk_uk_tier3', name: "Noir_SAR_MAR_APUK_UK_Tier3", path: 'C' },
    { id: 'noir_sar_mar_apuk_uk_tier4', name: "Noir_SAR_MAR_APUK_UK_Tier4", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier1', name: "Noir_SAR_SAM_APUK_UK_Tier1", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier1_manager', name: "Noir_SAR_SAM_APUK_UK_Tier1_Manager", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier2', name: "Noir_SAR_SAM_APUK_UK_Tier2", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier2_manager', name: "Noir_SAR_SAM_APUK_UK_Tier2_Manager", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier2_qa', name: "Noir_SAR_SAM_APUK_UK_Tier2_QA", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier3', name: "Noir_SAR_SAM_APUK_UK_Tier3", path: 'C' },
    { id: 'noir_sar_sam_apuk_uk_tier4', name: "Noir_SAR_SAM_APUK_UK_Tier4", path: 'C' },
];

// All permissions combined for lookup
const ALL_T321_PERMISSIONS = [...BASE_PERMISSIONS, ...REGULATED_PERMISSIONS, ...NOIR_PERMISSIONS];

const PATH_COLORS = {
    A: { bg: '#f0fdf4', color: '#166534', border: '#bbf7d0', label: 'Path A — Base (No PML, L7 approval)' },
    B: { bg: '#fffbeb', color: '#92400e', border: '#fde68a', label: 'Path B — Regulated (PML mandatory, SIM ticket)' },
    C: { bg: '#fef2f2', color: '#991b1b', border: '#fecaca', label: 'Path C — NOIR (PML mandatory, SIM ticket)' },
};

const T321ConfigPage = ({ userAlias }) => {
    const [teams, setTeams] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState('');
    const [editingTeam, setEditingTeam] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const [saveMessage, setSaveMessage] = useState('');

    // Form state for editing
    const [formTeamLabel, setFormTeamLabel] = useState('');
    const [formFunction, setFormFunction] = useState('');
    const [formOrgName, setFormOrgName] = useState('');
    const [formOrgAliases, setFormOrgAliases] = useState('');
    const [formApprovalLink, setFormApprovalLink] = useState('');
    const [formPermissions, setFormPermissions] = useState([]);
    const [expandedPath, setExpandedPath] = useState(null);
    const [permSearch, setPermSearch] = useState('');

    useEffect(() => { loadTeams(); }, []);

    const loadTeams = async () => {
        setIsLoading(true);
        setError('');
        try {
            const result = await listT321TeamConfigs();
            setTeams(result.teams || []);
        } catch (err) {
            setError('Failed to load T321 configs: ' + err.message);
        } finally {
            setIsLoading(false);
        }
    };

    const startNewTeam = () => {
        setEditingTeam('new');
        setFormTeamLabel('');
        setFormFunction('');
        setFormOrgName('');
        setFormOrgAliases('');
        setFormApprovalLink('');
        setFormPermissions([]);
        setExpandedPath(null);
        setPermSearch('');
        setSaveMessage('');
    };

    const startEditTeam = (team) => {
        setEditingTeam(team.teamLabel);
        setFormTeamLabel(team.teamLabel);
        setFormFunction(team.functionDropdown || '');
        setFormOrgName(team.orgName || '');
        setFormOrgAliases((team.orgAliases || []).join(', '));
        setFormApprovalLink(team.approvalLink || '');
        setFormPermissions(team.permissions || []);
        setExpandedPath(null);
        setPermSearch('');
        setSaveMessage('');
    };

    const cancelEdit = () => {
        setEditingTeam(null);
        setSaveMessage('');
    };

    const togglePermission = (permId) => {
        setFormPermissions(prev => {
            const exists = prev.find(p => p.id === permId);
            if (exists) return prev.filter(p => p.id !== permId);
            return [...prev, { id: permId, useCase: '' }];
        });
    };

    const updateUseCase = (permId, useCase) => {
        setFormPermissions(prev => prev.map(p => p.id === permId ? { ...p, useCase } : p));
    };

    const handleSave = async () => {
        if (!formTeamLabel.trim()) { alert('Team name is required'); return; }
        if (!formFunction) { alert('Function is required'); return; }
        if (!formOrgName.trim()) { alert('Org Name is required'); return; }
        setIsSaving(true);
        setSaveMessage('');
        try {
            await saveT321TeamConfig({
                teamLabel: formTeamLabel.trim(),
                functionDropdown: formFunction,
                orgName: formOrgName,
                orgAliases: formOrgAliases.split(',').map(s => s.trim()).filter(Boolean),
                approvalLink: formApprovalLink.trim(),
                permissions: formPermissions,
                active: true,
                updatedBy: userAlias || ''
            });
            setSaveMessage('✅ Saved successfully!');
            setEditingTeam(null);
            loadTeams();
        } catch (err) {
            setSaveMessage('❌ Error: ' + err.message);
        } finally {
            setIsSaving(false);
        }
    };

    const handleDelete = async (teamLabel) => {
        if (!window.confirm(`Delete T321 config for "${teamLabel}"?`)) return;
        try {
            await deleteT321TeamConfig(teamLabel);
            loadTeams();
        } catch (err) {
            alert('Delete failed: ' + err.message);
        }
    };

    // Count permissions per path
    const getPathCount = (pathId) => {
        return formPermissions.filter(p => {
            const perm = ALL_T321_PERMISSIONS.find(ap => ap.id === p.id);
            return perm && perm.path === pathId;
        }).length;
    };

    // ════════════════════════════════════════
    // RENDER: Edit/Create Form
    // ════════════════════════════════════════
    if (editingTeam) {
        return (
            <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
                <button onClick={cancelEdit} style={{ padding: '6px 14px', borderRadius: '6px', fontSize: '13px', cursor: 'pointer', border: '1px solid #ddd', background: '#fff', color: '#666', marginBottom: '16px' }}>
                    ← Back to List
                </button>

                <h2 style={{ fontSize: '18px', fontWeight: '700', marginBottom: '20px' }}>
                    {editingTeam === 'new' ? '➕ Add New T321 Team' : `✏️ Edit: ${editingTeam}`}
                </h2>

                {/* Team Name */}
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Team Name *</label>
                    <input type="text" value={formTeamLabel}
                        onChange={(e) => setFormTeamLabel(e.target.value)}
                        placeholder="e.g., APE Compliance EU"
                        disabled={editingTeam !== 'new'}
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px', backgroundColor: editingTeam !== 'new' ? '#f3f4f6' : '#fff' }} />
                </div>

                {/* Function & Org */}
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px', marginBottom: '16px' }}>
                    <div>
                        <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Function</label>
                        <select value={formFunction} onChange={(e) => setFormFunction(e.target.value)}
                            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' }}>
                            <option value="">-- Select Function --</option>
                            <option value="Operations Team">Operations Team</option>
                            <option value="Tech Team">Tech Team</option>
                            <option value="Support Function">Support Function</option>
                            <option value="Compliance">Compliance</option>
                            <option value="Investigations">Investigations</option>
                        </select>
                    </div>
                    <div>
                        <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Org Name</label>
                        <input type="text" value={formOrgName}
                            onChange={(e) => setFormOrgName(e.target.value)}
                            placeholder="e.g., RCS Compliance"
                            style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' }} />
                    </div>
                </div>

                {/* Org Aliases (valid department names) */}
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Valid Department Names (comma-separated)</label>
                    <input type="text" value={formOrgAliases}
                        onChange={(e) => setFormOrgAliases(e.target.value)}
                        placeholder="e.g., APE-Compliance, APUK-Compliance, RCS-EU"
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' }} />
                    <div style={{ fontSize: '11px', color: '#666', marginTop: '4px' }}>Users whose department matches any of these will be detected as a listed (pre-approved) use case.</div>
                </div>

                {/* Approval Link */}
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '6px' }}>Leadership Approval Link</label>
                    <input type="text" value={formApprovalLink}
                        onChange={(e) => setFormApprovalLink(e.target.value)}
                        placeholder="https://approvals.amazon.com/approval/..."
                        style={{ width: '100%', padding: '10px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '14px' }} />
                </div>

                {/* Permissions — grouped by path */}
                <div style={{ marginBottom: '16px' }}>
                    <label style={{ display: 'block', fontWeight: '600', fontSize: '13px', marginBottom: '10px' }}>
                        Approved Permissions ({formPermissions.length} selected)
                    </label>

                    {/* Search */}
                    <input type="text" value={permSearch}
                        onChange={(e) => setPermSearch(e.target.value)}
                        placeholder="Search permissions..."
                        style={{ width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #ddd', fontSize: '13px', marginBottom: '12px' }} />

                    {['A', 'B', 'C'].map(pathId => {
                        const pc = PATH_COLORS[pathId];
                        const permsOfPath = (pathId === 'A' ? BASE_PERMISSIONS : pathId === 'B' ? REGULATED_PERMISSIONS : NOIR_PERMISSIONS)
                            .filter(p => !permSearch || p.name.toLowerCase().includes(permSearch.toLowerCase()));
                        const isExpanded = expandedPath === pathId;
                        const selectedCount = getPathCount(pathId);

                        return (
                            <div key={pathId} style={{ marginBottom: '12px', border: '1px solid #e2e6ea', borderRadius: '8px', overflow: 'hidden' }}>
                                <div
                                    onClick={() => setExpandedPath(isExpanded ? null : pathId)}
                                    style={{ padding: '10px 14px', background: pc.bg, fontWeight: '600', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '8px', cursor: 'pointer', justifyContent: 'space-between' }}
                                >
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        <span style={{ padding: '2px 8px', borderRadius: '8px', fontSize: '11px', fontWeight: '700', backgroundColor: pc.bg, color: pc.color, border: `1px solid ${pc.border}` }}>
                                            Path {pathId}
                                        </span>
                                        <span style={{ color: '#374151' }}>{pc.label.split('—')[1]}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                        {selectedCount > 0 && (
                                            <span style={{ padding: '2px 8px', borderRadius: '10px', fontSize: '11px', fontWeight: '700', background: '#166534', color: '#fff' }}>
                                                {selectedCount} selected
                                            </span>
                                        )}
                                        <span style={{ fontSize: '12px', color: '#666' }}>{isExpanded ? '▼' : '▶'} {permsOfPath.length}</span>
                                    </div>
                                </div>
                                {isExpanded && (
                                    <div style={{ maxHeight: '300px', overflowY: 'auto' }}>
                                        {permsOfPath.map(perm => {
                                            const isSelected = formPermissions.some(p => p.id === perm.id);
                                            const permConfig = formPermissions.find(p => p.id === perm.id);
                                            return (
                                                <div key={perm.id} style={{ padding: '8px 14px', borderTop: '1px solid #f0f0f0', background: isSelected ? '#f0fdf4' : '#fff' }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                        <input type="checkbox" checked={isSelected} onChange={() => togglePermission(perm.id)}
                                                            style={{ width: '16px', height: '16px', cursor: 'pointer' }} />
                                                        <span style={{ fontWeight: '500', fontSize: '13px' }}>{perm.name}</span>
                                                    </div>
                                                    {isSelected && (
                                                        <div style={{ marginTop: '6px', marginLeft: '26px' }}>
                                                            <input type="text" value={permConfig?.useCase || ''}
                                                                onChange={(e) => updateUseCase(perm.id, e.target.value)}
                                                                placeholder="Use case (auto-populates for end user)..."
                                                                style={{ width: '100%', padding: '6px 10px', borderRadius: '5px', border: '1px solid #ddd', fontSize: '12px' }} />
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        );
                    })}
                </div>

                {/* Save */}
                {saveMessage && <div style={{ marginBottom: '12px', fontSize: '14px', fontWeight: '600' }}>{saveMessage}</div>}
                <button onClick={handleSave} disabled={isSaving}
                    style={{ padding: '12px 24px', borderRadius: '6px', fontSize: '14px', fontWeight: '700', cursor: 'pointer', border: 'none', background: '#ff9900', color: '#000', width: '100%' }}>
                    {isSaving ? '⏳ Saving...' : '💾 Save T321 Configuration'}
                </button>
            </div>
        );
    }

    // ════════════════════════════════════════
    // RENDER: Team List
    // ════════════════════════════════════════
    return (
        <div style={{ padding: '20px', maxWidth: '900px', margin: '0 auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h2 style={{ fontSize: '18px', fontWeight: '700', margin: 0 }}>⚙️ T321 Team Permission Config</h2>
                <button onClick={startNewTeam}
                    style={{ padding: '8px 16px', borderRadius: '6px', fontSize: '13px', fontWeight: '600', cursor: 'pointer', border: 'none', background: '#ff9900', color: '#000' }}>
                    ➕ Add Team
                </button>
            </div>

            {/* Info banner */}
            <div style={{ padding: '12px 16px', borderRadius: '8px', background: '#f0f8ff', border: '1px solid #b8d4f0', marginBottom: '16px', fontSize: '12px', color: '#0073bb' }}>
                ℹ️ Teams configured here will be matched against requesters' departments on the T321 (PRISM) request page. Matched users see a "Pre-Approved" flow with only the configured permissions.
            </div>

            {error && <div style={{ padding: '12px', borderRadius: '6px', background: '#ffeef0', border: '1px solid #ffc1c8', color: '#d13212', marginBottom: '16px' }}>❌ {error}</div>}

            {isLoading ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>Loading...</div>
            ) : teams.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '40px', color: '#888' }}>
                    <div style={{ fontSize: '40px', marginBottom: '12px' }}>📭</div>
                    <p>No T321 teams configured yet. Click "Add Team" to get started.</p>
                </div>
            ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '10px' }}>
                    {teams.map(team => {
                        const permCount = team.permissionCount || (team.permissions || []).length || 0;
                        // Count per path
                        const perms = team.permissions || [];
                        const pathACnt = perms.filter(p => ALL_T321_PERMISSIONS.find(ap => ap.id === p.id && ap.path === 'A')).length;
                        const pathBCnt = perms.filter(p => ALL_T321_PERMISSIONS.find(ap => ap.id === p.id && ap.path === 'B')).length;
                        const pathCCnt = perms.filter(p => ALL_T321_PERMISSIONS.find(ap => ap.id === p.id && ap.path === 'C')).length;

                        return (
                            <div key={team.teamLabel} style={{ padding: '16px', borderRadius: '10px', border: '1px solid #e2e6ea', background: '#fff', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <div>
                                    <div style={{ fontWeight: '700', fontSize: '15px', color: '#333' }}>{team.teamLabel}</div>
                                    <div style={{ fontSize: '12px', color: '#888', marginTop: '4px', display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                                        <span>{permCount} permissions</span>
                                        {pathACnt > 0 && <span style={{ padding: '1px 6px', borderRadius: '4px', background: '#f0fdf4', color: '#166534', border: '1px solid #bbf7d0' }}>A:{pathACnt}</span>}
                                        {pathBCnt > 0 && <span style={{ padding: '1px 6px', borderRadius: '4px', background: '#fffbeb', color: '#92400e', border: '1px solid #fde68a' }}>B:{pathBCnt}</span>}
                                        {pathCCnt > 0 && <span style={{ padding: '1px 6px', borderRadius: '4px', background: '#fef2f2', color: '#991b1b', border: '1px solid #fecaca' }}>C:{pathCCnt}</span>}
                                        <span>· Updated by {team.updatedBy || '—'}</span>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '8px' }}>
                                    <button onClick={() => startEditTeam(team)}
                                        style={{ padding: '6px 12px', borderRadius: '5px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', border: '1px solid #0073bb', background: '#f0f8ff', color: '#0073bb' }}>
                                        ✏️ Edit
                                    </button>
                                    <button onClick={() => handleDelete(team.teamLabel)}
                                        style={{ padding: '6px 12px', borderRadius: '5px', fontSize: '12px', fontWeight: '600', cursor: 'pointer', border: '1px solid #d13212', background: '#ffeef0', color: '#d13212' }}>
                                        🗑️ Delete
                                    </button>
                                </div>
                            </div>
                        );
                    })}
                </div>
            )}
        </div>
    );
};

export default T321ConfigPage;
